import { ResetUserPasswordRequest } from '@pages/reset-password/models/reset-user-password-request.interface';

const actionScope = '[Reset Password]';

export class ValidateCode {
  static readonly type = `${actionScope} Validate Code`;
  constructor(public readonly passwordCodeKey: string) {}
}

export class ResetPassword {
  static readonly type = `${actionScope} Reset Password`;
  constructor(public readonly request: ResetUserPasswordRequest) {}
}
